import { useMemo } from "react";
import { type RequestState, useAuthenticatedRequest } from "./request";

export interface HelpCenterItem {
  id: string;
  displayName: string;
  items: any[];
}

export interface HelpCenterResult {
  data: HelpCenterItem[];
}

export function useHelpCenter(
  language: string = "en",
  isInternal: boolean,
): RequestState<HelpCenterResult> {
  const config = useMemo(() => {
    const params = new URLSearchParams();
    params.set("language", language);
    return { params };
  }, [language]);

  const url = isInternal
    ? "/v0/content/help-center-internal"
    : "/v0/content/help-center";

  return useAuthenticatedRequest<HelpCenterResult>(url, config);
}
